<template>
  <div
    class="table-search-container"
  >
    <a-input-search
      class="select-container"
      placeholder="请输入调研模板名称"
      style="width:200px;"
      @search="value => $emit('onSearch', value)"
    />
    <a-input-search
      class="select-container"
      placeholder="请输入用户"
      style="width:200px;"
      @search="value => $emit('onSearchUser', value)"
    />

    时间：
    <a-date-picker @change="value=>$emit('onStartTime',value)" />
    <a-date-picker
      class="select-container"
      @change="value=>$emit('onEndTime',value)"
    />
    <a-button
      type="primary"
      shape="round"
      icon="download"
      @click="$emit('onExport')"
    >
      导出
    </a-button>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
};
</script>
<style lang="scss">
.table-search-container {
  height: 70px;
  line-height: 70px;
  .ant-input {
    border-radius: 15px;
    height: 30px;
  }
  .ant-btn-round {
    font-size: 12px;
    height: 30px;
    padding: 0 17px;
    border-radius: 15px;
  }
  .select-container{
    margin-right:10px;
  }
}
</style>
